var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.isEditing
            ? _vm.$t("pages.admin.faq.create_edit.title_edit")
            : _vm.$t("pages.admin.faq.create_edit.title"),
          "icon-class": "mdi mdi-frequently-asked-questions"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 grid-margin stretch-card" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c(
                  "language-switcher-nav",
                  {
                    attrs: { language: _vm.selectedLanguage },
                    on: {
                      "update:language": function($event) {
                        _vm.selectedLanguage = $event
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          { attrs: { for: "title_" + _vm.selectedLanguage } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("pages.admin.faq.global.title"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.titles[_vm.selectedLanguage],
                              expression: "titles[selectedLanguage]"
                            }
                          ],
                          staticClass: "form-control form-control-lg",
                          class: {
                            "is-invalid": _vm.$errors.has(
                              "titles." + _vm.selectedLanguage
                            )
                          },
                          attrs: {
                            id: "title_" + _vm.selectedLanguage,
                            type: "text",
                            placeholder: _vm.$t("pages.admin.faq.global.title")
                          },
                          domProps: { value: _vm.titles[_vm.selectedLanguage] },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.titles,
                                _vm.selectedLanguage,
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("error-no-form-field", {
                          attrs: { input: "titles." + _vm.selectedLanguage }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          { attrs: { for: "text_" + _vm.selectedLanguage } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("pages.admin.faq.global.text"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("VueTrix", {
                          attrs: {
                            id: "text_" + _vm.selectedLanguage,
                            placeholder: _vm.$t("pages.admin.faq.global.text")
                          },
                          model: {
                            value: _vm.texts[_vm.selectedLanguage],
                            callback: function($$v) {
                              _vm.$set(_vm.texts, _vm.selectedLanguage, $$v)
                            },
                            expression: "texts[selectedLanguage]"
                          }
                        }),
                        _vm._v(" "),
                        _c("error-no-form-field", {
                          attrs: { input: "texts." + _vm.selectedLanguage }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [
                    _c("strong", [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.$t("pages.admin.faq.create_edit.image")) +
                          "\n                            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-2 mb-2" }, [
                    _vm.current_image_url !== null
                      ? _c("img", {
                          staticClass: "img-fluid",
                          staticStyle: { "max-height": "100px" },
                          attrs: {
                            src: _vm.current_image_url,
                            alt: _vm.titles.en
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "file-upload-default",
                    class: { "is-invalid": _vm.$errors.has("file") },
                    attrs: { type: "file", id: "file" },
                    on: { change: _vm.fileSelected }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "input-group cursor-pointer col-xs-12",
                      on: { click: _vm.showSelectFileDialog }
                    },
                    [
                      _c("input", {
                        staticClass: "form-control file-upload-info",
                        attrs: {
                          type: "text",
                          disabled: "",
                          placeholder: _vm.$t(
                            "pages.admin.faq.create_edit.image"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "file-upload-browse btn btn-gradient-primary",
                            attrs: { type: "button" }
                          },
                          [_vm._v(_vm._s(_vm.$t("actions.select")))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("error", { attrs: { input: "file" } })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.saveQuestion }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.isEditing
                            ? _vm.$t("pages.admin.faq.create_edit.update")
                            : _vm.$t("pages.admin.faq.create_edit.create")
                        ) +
                        "\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }